import { Box, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import numbers from '@common/utility/numbers';
import React from 'react';
import { CURRENCY_OPTIONS } from '../../constants';
import { useStatementViewModel } from '../../models/StatementViewModel';

export const Holdings: React.FC = () => {
  const statementViewModel = useStatementViewModel();

  const holdings = statementViewModel.statement?.holdings;

  if (!holdings) return null;

  return (
    <Box w="full">
      <TableContainer>
        <Table px={'0px'} layout="fixed">
          <Thead>
            <Tr>
              <Td
                pl={'0px'}
                borderBottomStyle="none"
                fontSize="16px"
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                colSpan={6}>
                Holdings
              </Td>
            </Tr>
            <Tr py="6px" borderBottom={'2px solid black'}>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                pl={'0px'}
                color="black">
                Investment
              </Th>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Type
              </Th>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Starting Shares
              </Th>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Ending Shares <sup>1</sup>
              </Th>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Estimated Price <sup>2</sup>
              </Th>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Ending Value <sup>3</sup>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {holdings.items?.map((item, i) => (
              <Tr py="6px" key={`holding-${i}`}>
                <Td lineHeight={1} pl="4px">
                  {item.subscription_offer_name}
                </Td>
                <Td lineHeight={1}>{item.type}</Td>
                <Td lineHeight={1}>
                  {numbers.format(parseFloat(item.start_shares), {
                    maximumFractionDigits: 10,
                    minimumFractionDigits: 0,
                  })}
                </Td>
                <Td lineHeight={1}>
                  {numbers.format(parseFloat(item.end_shares), { maximumFractionDigits: 10, minimumFractionDigits: 0 })}
                </Td>
                <Td lineHeight={1}>{currency.format(item.end_share_price, CURRENCY_OPTIONS)}</Td>
                <Td lineHeight={1}>{currency.format(parseFloat(item.end_value), CURRENCY_OPTIONS)}</Td>
              </Tr>
            ))}
            <Tr py="6px" backgroundColor="gray.50">
              <Td pl="4px" colSpan={5} fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                Total
              </Td>
              <Td fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                {currency.format(holdings.totals.end_value, CURRENCY_OPTIONS)}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
